<template>
    <div class="input-group">

        <textarea v-model="text" :name="name" class="form-control" :id="id" :placeholder="placeholder"></textarea>

        <div class="input-group-append">
            <span class="input-group-text" :class="cssObject">
                <span :class="">{{ length }}</span> / {{ maxLength}}
            </span>
        </div>
    </div>

    
</template>

<script>
  import MetaInfo from './MetaInfo';

  export default {
    name: "meta-description",
    mixins: [MetaInfo],
    props: {
      id: {
        required: false,
        default: 'meta-description-input',
      },
      name: {
        required: false,
        default: 'meta_description',
      },
      maxLength: {
        required: false,
        type: Number,
        default: 144,
      },
    }
  }
</script>

<style scoped>

</style>